import { createSelector } from '@reduxjs/toolkit';

import cloneDeep from 'lodash.clonedeep';
import QueryFilter from '../helpers/query-filter';
import type { RootState } from '../reducers';

export const getFacetList = createSelector(
  (state: RootState) => state.search.facetList,
  (facetList) => {
    if (!facetList || !facetList.length) {
      return [];
    }

    return facetList || [];
  },
);

export const getManufactureFacetList = (state: RootState) => {
  const facetList = getFacetList(state);
  if (facetList) {
    const manufacturerFacets = facetList.find((x) => x.id === 'manufacturer');
    if (manufacturerFacets && manufacturerFacets.filters) return manufacturerFacets.filters;
  }
  return null;
};

export const getQueryFilter = createSelector(
  (state: RootState) => state.search.queryFilter || '',
  (queryFilter) => new QueryFilter(queryFilter),
);

export const getSearchInitialized = (state: RootState) => state.search.initialized;

export const getFacets = createSelector(
  (state: RootState) => state.search.facets,
  (facets) => cloneDeep(facets || []),
);
